import { createFileRoute } from "@tanstack/react-router";
import { DoomscrollRoutePage } from "@/app-clients/browse-dogs/routes/discover-route";
import { browseDogsDiscoverRoute } from "@/app-clients/browse-dogs/routes/discover-route-data";

export const Route = createFileRoute("/discover")({
    validateSearch: browseDogsDiscoverRoute.validateSearch,
    loaderDeps: browseDogsDiscoverRoute.loaderDeps,
    ssr: browseDogsDiscoverRoute.ssr,
    preload: false,
    beforeLoad: browseDogsDiscoverRoute.beforeLoad,
    loader: browseDogsDiscoverRoute.loader,
    head: browseDogsDiscoverRoute.head,
    component: DoomscrollRoutePage,
});
